import { Alert } from '@mui/material';
import { PageContainer } from '@tiles-erp/ui';
import { useAuth } from '../../auth/AuthProvider';
import { BackupSettings } from './BackupSettings';

export function BackupRestorePage(): JSX.Element {
  const { user } = useAuth();
  const allowed = Boolean(user && (user.email.toLowerCase() === 'dinez17@gmail.com' || user.roles.some(role => ['ADMIN', 'SUPER_ADMIN'].includes(role))));
  return (
    <PageContainer title="Backup and restore" subtitle="Download full ERP backups and restore a saved backup.">
      {allowed ? <BackupSettings /> : <Alert severity="error">Only Admin, Superadmin and dinez17@gmail.com can access backup and restore.</Alert>}
    </PageContainer>
  );
}
